<template>
    <div>
        <HeaderSection icon="fas fa-folder-open" title="Edición de Plantillas">
            <template slot="buttons">
                <el-button
                    size="medium"
                    type="primary"
                    icon="fas fa-plus"
                    @click="createTemplate()">
                    Agregar Plantilla
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    icon="el-icon-arrow-left"
                    @click="goToBack">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>
        <br>

        <el-tabs v-model="activeName" type="border-card">
            <el-tab-pane label="Plantillas" name="templates">
                <el-table :data="templates" border min-height="450" style="width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="scope">
                            <TemplateActions :procedures="scope.row.procedures"
                                             :trades="trades"
                                             :tradesTrust="tradesTrust"
                                             :isTemplate="true"
                                             :alias_this="alias_this"/>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="Tipo de Trámite"/>
                </el-table>
            </el-tab-pane>
        </el-tabs>

        <el-dialog title="Agregar Plantilla"
                   :visible.sync="addTemplate"
                   :close-on-press-escape="false"
                   :close-on-click-modal="false">
            <el-form @submit.native.prevent ref="newTemplate" :model="newTemplate" label-width="120px"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Categoría"
                                      prop="cat_category_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="newTemplate.cat_category_id"
                                       style="width: 100%"
                                       placeholder="Seleccione una Categoría" filterable>
                                <el-option
                                    v-for="item in templates"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Trámite"
                                      prop="cat_procedure_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="newTemplate.cat_procedure_id" style="width: 100%"
                                       placeholder="Seleccione un Trámite" filterable>
                                <el-option
                                    v-for="item in procedures.filter(up => up.cat_category_id == newTemplate.cat_category_id) "
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Nombre de la Plantilla"
                                      prop="name"
                                      :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'change' },
                                      { max: 70, message: 'Este campo debería ser de máximo 70 caracteres', trigger: 'blur' },
                                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                            <el-input v-my-only-alphanumeric="{maxChars: 70}" :maxlength="70"
                                      @change="checkTemplate(newTemplate)" v-model="newTemplate.name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="¿Esta plantilla es una hoja de ayuda?">
                            <el-switch
                                @change="searchHelp(newTemplate)"
                                v-model="newTemplate.isHelp"
                                :disabled="newTemplate.first"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item
                            label="¿Esta plantilla es un oficio?">
                            <el-switch
                                v-model="newTemplate.isPaper"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Certificación con QR">
                            <el-switch
                                v-model="newTemplate.isQr"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" v-if="newTemplate.cat_category_id == 1 && newTemplate.isPaper">
                        <el-form-item label="Oficios Adquisiciones"
                                      prop="cat_trade_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="newTemplate.cat_trade_id" style="width: 100%"
                                       placeholder="Seleccione un Oficio" filterable>
                                <el-option
                                    v-for="item in trades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="newTemplate.cat_category_id == 2 && newTemplate.isPaper">
                        <el-form-item label="Oficios Fideicomisos"
                                      prop="cat_trade_trust_id"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select v-model="newTemplate.cat_trade_trust_id" style="width: 100%"
                                       placeholder="Seleccione un Oficio" filterable>
                                <el-option
                                    v-for="item in tradesTrust"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="newTemplate.isHelp">
                    <el-col :span="12">
                        <el-form-item label="Monto a pagar en MXN"
                                      prop="name"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <vue-numeric currency="$"
                                         class="el-input__inner"
                                         separator=","
                                         v-model="newTemplate.amount"
                                         :precision="2"
                            ></vue-numeric>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="Acuse de registro"
                            prop="first"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-switch
                                @change="disabledSwitch(newTemplate)"
                                v-model="newTemplate.first"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Requiere Firma electrónica">
                            <el-switch
                                v-model="newTemplate.isSigned"
                                active-text="Sí"
                                inactive-color="#13322B"
                                active-color="#9d2438"
                                inactive-text="No">
                            </el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                        <el-button
                            type="danger"
                            icon="fas fa-times"
                            @click="addTemplate=false">
                            Cancelar
                        </el-button>
                        <el-button
                            type="primary"
                            icon="fas fa-save"
                            @click="saveNewTemplate()">
                            Guardar Plantilla
                        </el-button>
                    </span>
        </el-dialog>


    </div>
</template>

<script>
import HeaderSection from '../../../../partials/HeaderSection';
import TemplateActions from './partials/TemplateActions'

export default {
    components: {
        HeaderSection,
        TemplateActions
    },

    computed: {
        alias_this() {
            return this;
        },
    },

    data() {
        return {
            activeName: 'templates',
            categories: [],
            templates: [],
            procedures: [],
            trades: [],
            tradesTrust: [],
            addTemplate: false,
            newTemplate: {
                cat_category_id: '',
                cat_procedure_id: '',
                name: '',
                description: '',
                first: false,
                isHelp: false,
                isQr: false,
            },
            newProcedure: {},
            isValid: false,
            addProcedure: false,

        }

    },

    created() {
        this.getAgreements();
    },

    methods: {

        disabledSwitch(register) {
            if (register.first) {
                //register.isSigned = false;
                register.isHelp = false
            }

        },

        goToBack() {
            this.$router.push('/administracion')
        },
        redirect(row) {
            this.$router.push('/administracion/gestion-de-plantilla-document/' + row.hash_id)
        },
        showLoading() {
            this.$store.dispatch(
                'loading/spinner',
                {msg: 'Cargando Datos...', status: true},
                {root: true}
            );
        },
        hideLoading() {
            this.$store.dispatch('loading/spinner', {}, {root: true});
        },

        getAgreements() {
            this.showLoading();

            axios.get('/api/templates/get-templates').then(response => {
                this.hideLoading();
                this.templates = response.data.templates;
                this.procedures = response.data.procedures;
                this.trades = response.data.trades;
                this.tradesTrust = response.data.tradesTrust;

            }).catch(error => {
                this.$store.dispatch('loading/spinner', {}, {root: true});
                this.$notify.error({
                    title: 'Error',
                    message: 'No fue posible mostrar información'
                });
            });
        },

        saveNewTemplate() {
            this.$refs['newTemplate'].validate((valid) => {
                if (valid) {
                    this.showLoading();
                    axios.post('/api/templates/new-template', this.newTemplate).then(response => {
                        this.hideLoading();
                        if (response.data.success) {
                            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
                            this.getAgreements();
                            this.addTemplate = false;
                        } else {
                            this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                        }

                    }).catch(error => {
                        this.$store.dispatch('loading/spinner', {}, {root: true});
                        this.$notify.error({
                            title: 'Error',
                            message: 'No fue posible mostrar información'
                        });
                    });
                } else {
                    this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos'}, {root: true});
                }
            })

        },

        filterTemplates() {

            if (this.templates) {

                let _array = [];
                _.forEach(this.templates, item => {
                    _array.push({
                        id: item.id,
                        name: item.name
                    })
                });
                return _array
            }
        },

        createTemplate() {
            this.newTemplate.cat_category_id = '';
            this.newTemplate.cat_procedure_id = '';
            this.newTemplate.description = '';
            this.newTemplate.name = null;
            this.newTemplate.first = false;
            this.newTemplate.isHelp = false;
            this.newTemplate.isQr = false;
            this.addTemplate = true;
        },

        showEdit(agreement, paper) {

        },

        goToCreate() {

            this.$store.dispatch('notifications/warning', {msg: 'Por favor... Mantenga abierta esta pestaña, será redireccionado al módulo correspondiente.'}, {root: true});

            setTimeout(() => {
                let url = `/administracion/catalogos?showProcedure=true`;
                window.open(url, '_blank');
            }, 2000)
        },

        searchHelp(element) {
            if (element.cat_procedure_id && element.cat_category_id) {
                element.isHelp ? element.first = false : null;
                element.isHelp ? element.isSigned = false : null;
                axios.get('/api/search-help', {params: element}).then(response => {
                    if (!response.data.success) {
                        element.isHelp = false;
                        this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});
                    }
                })
            } else {
                element.isHelp = false
                this.$store.dispatch('notifications/warning', {msg: 'Primero seleccione una Categoría y un Tipo de trámite.'}, {root: true});
            }
        },

        checkTemplate(element) {
            if (element.cat_procedure_id && element.cat_category_id) {
                axios.get('/api/check-template', {params: element}).then(response => {
                    if (!response.data.success) {
                        this.newTemplate.name = '';
                        this.$store.dispatch('notifications/warning', {msg: response.data.message}, {root: true});
                    }
                })
            } else {
                this.newTemplate.isHelp = false
                this.$store.dispatch('notifications/warning', {msg: 'Primero seleccione una Categoría y un Tipo de trámite.'}, {root: true});
            }
        }


    }

}


</script>

<style>
</style>
